export default __webpack_public_path__ + "static/media/laundry1-beforeA-768w.be637169.avif";